import { type FunctionComponent } from 'react';
import { generateCloudinaryUrl } from '../../../helpers/cloudinary-helper/cloudinary-helper';
import { type PromoBannerVariationOptions } from '../../../types/promo-banner.types';
import { CloudinaryImage } from '../../images/cloudinary-image/cloudinary-image.component';
import { BannerImage } from '../banner-image/banner-image.component';
import { DoorMarker } from '../promo-helpers/door-marker.component';
import { defaultCouponExpirationString } from '../promo-helpers/promo-banner.helpers';

export const SecondaryPromoB: FunctionComponent<PromoBannerVariationOptions> = ({
	headline,
	subHeading,
	couponCode,
	expirationDate,
	action,
	image,
	imageShade,
	imageOverlay
}) => {
	const backgroundUrl = generateCloudinaryUrl(image.id, {
		width: 950,
		height: undefined,
		gravity: 'custom',
		zoom: '0.9',
		crop: 'thumb'
	});
	return (
		<BannerImage
			className="min-h4 pa3 ba b--theme-grey-light bg-theme-black-o30 cover"
			backgroundUrl={backgroundUrl}
			imageShade={imageShade || 'DARK'}
			preload={false}>
			<div className="font-medium f4 theme-white">{headline}</div>
			<div className="f6 lh-title mt2 theme-white">{subHeading}</div>
			{(couponCode || expirationDate) && (
				<div className="f7 mt2 theme-white">
					<DoorMarker color="white" />
					<span className="nowrap">{defaultCouponExpirationString(couponCode, expirationDate)}</span>
				</div>
			)}
			<div>
				<div className="flex justify-between mt3">
					{imageOverlay ? (
						<CloudinaryImage
							publicID={imageOverlay.id}
							description="promo"
							className="db max-h-100"
							options={{ width: 100, height: undefined, crop: 'lfill', gravity: 'custom', preserveTransparency: true }}
							useDimensions={false}
						/>
					) : (
						<div className="h2 w2" />
					)}
					<div className="relative w-50">
						<div className="absolute bottom-0 f6 right-0 theme-white">{action?.name || ''}</div>
					</div>
				</div>
			</div>
		</BannerImage>
	);
};
